import React, { CSSProperties, ReactNode } from "react";
import { AppButton, AppButtonProps } from "../../atoms/Button";

type ButtonProps = AppButtonProps & { label: ReactNode };

export type ButtonGroupProps = {
  primaryButton?: ButtonProps;
  secondaryButton?: ButtonProps;
  align?: CSSProperties["justifyContent"];
  gap?: number;
  style?: CSSProperties;
  layout?: "inline" | "split";
  accessory?: ReactNode;
};

const renderSecondaryButton = (secondaryButton: ButtonProps) => (
  <AppButton variant="secondary" {...(({ label, ...rest }) => rest)(secondaryButton)}>
    {secondaryButton.label}
  </AppButton>
);

const renderPrimaryButton = (primaryButton: ButtonProps) => (
  <AppButton variant="primary" {...(({ label, ...rest }) => rest)(primaryButton)}>
    {primaryButton.label}
  </AppButton>
);

export const ButtonGroup = (props: ButtonGroupProps) => {
  const { primaryButton, secondaryButton, align = "end", gap = 8, style, layout = "inline", accessory } = props;

  if (!primaryButton && !secondaryButton) return null;

  if (layout === "split")
    return (
      <div style={{ display: "flex", width: "100%", justifyContent: "space-between", alignItems: "center", ...style }}>
        <div>{secondaryButton && renderSecondaryButton(secondaryButton)}</div>
        <div style={{ display: "flex", alignItems: "center", gap }}>
          {accessory}
          {primaryButton && renderPrimaryButton(primaryButton)}
        </div>
      </div>
    );

  return (
    <div style={{ display: "flex", width: "100%", justifyContent: align, gap, ...style }}>
      {secondaryButton && renderSecondaryButton(secondaryButton)}

      {primaryButton && renderPrimaryButton(primaryButton)}
    </div>
  );
};
